import { FC, SVGProps } from "react";

const PointsIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      stroke="currentcolor"
      {...props}
    >
      <g clipPath="url(#clip0_658_3032)">
        <path d="M9.75 14C9.75 15.657 12.6598 17 16.25 17C19.8402 17 22.75 15.657 22.75 14C22.75 12.343 19.8402 11 16.25 11C12.6598 11 9.75 12.343 9.75 14Z" />
        <path d="M9.75 14V18C9.75 19.656 12.6598 21 16.25 21C19.8402 21 22.75 19.656 22.75 18V14" />
        <path d="M3.25 6C3.25 7.072 4.48933 8.062 6.5 8.598C8.51067 9.134 10.9893 9.134 13 8.598C15.0107 8.062 16.25 7.072 16.25 6C16.25 4.928 15.0107 3.938 13 3.402C10.9893 2.866 8.51067 2.866 6.5 3.402C4.48933 3.938 3.25 4.928 3.25 6Z" />
        <path d="M3.25 6V16C3.25 16.888 4.08633 17.45 5.41667 18" />
        <path d="M3.25 11C3.25 11.888 4.08633 12.45 5.41667 13" />
      </g>
      <defs>
        <clipPath id="clip0_658_3032">
          <rect width="26" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PointsIcon;
